export const fetchSearchData = async (query) => {
    const url = `https://api.dofusdu.de/dofus2/fr/items/equipment/search?query=${query}&filter%5Bmin_level%5D=50&filter%5Bmax_level%5D=200&limit=10`;
  
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des données');
        }
        return response.json();
      })
      .then(data => {
        console.log("apifetchsearch",data);
        if (data.items) {
          const itemIds = data.items.map(item => item.ankama_id);
          return itemIds;
        }
        return data.map(item => item.ankama_id); // ou une autre valeur par défaut si data.items est undefined
      });
  };
  